import { render, staticRenderFns } from "./FakePageTitle.vue?vue&type=template&id=7579e6a0&"
import script from "./FakePageTitle.vue?vue&type=script&lang=ts&"
export * from "./FakePageTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports